import { render } from "./StateLabel.vue?vue&type=template&id=14f08c80"
import script from "./StateLabel.vue?vue&type=script&lang=js"
export * from "./StateLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__